import TimeSettingPage from './TimeSettingPage';
export default TimeSettingPage